<template>
  <router-view/>
</template>

<script>
export default {
  name: "Reports"
}
</script>

<style scoped>

</style>